import ModalViewRight from "./modal-view-right";

export default ModalViewRight;